<template>
	<div class="tplContainer">
		<div class="width1200">
			<audiotpl v-if="showtype==3" :dataChange="dataChange" :generated="generated" :extra='extra' :videoData="videoData" @showMedialists="showMedialists"></audiotpl>
			<a-modal  :destroyInClose="true"  cancelText="取消" okText="确认" :centered="true" :visible="visible" @ok="handleOk" @cancel="handleCancle" title="选择文件" width="92%" :destroyOnClose="true"
				wrapClassName="full-modal">
				<div style="width: 100%; height: calc(100vh - 248px);">
					<audioManage v-if="showtype==3" :isPageOrModel="isPageOrModel" @getlistsfromLib="getlistsfromLib"></audioManage>
				</div>	
			</a-modal>
		</div>
	</div>
</template>

<script>
	import audiotpl from "../../components/audio.vue";
	import audioManage from '../audioManage/App.vue';
	import {
		message
	} from 'ant-design-vue';
	export default {
		name: 'Home',
		components: {
			audiotpl,
			audioManage
		},
		data() {
			return {
				isPageOrModel: 2,
				visible: false,
				extra:{
					path:'',
					qrcode_url:''
				},
				showtype: 3, //1默认页面，2视频上传，3音频上传
				videoData: {
					change_type: 2, //转换形式:1二维码，2链接
					mode: 1, //打开方式:1小程序，2无标识小程序，3h5
					design: 1, //视频款式:1标准，2视频集，3视频刷一刷
					title: '',
					createCodeStatus:0,//>1隐藏切换按钮
					bjcolor: "#FFFFFF",
					/*背景色*/
					url_info: {
						url_type: 1, //域名:1默认，2vip，3自有
						url: ''
					},
					lists: [], //
				},
				libLists: [], //从附件库选择的附件
				generated:{
					generated:false,
					
				},
				dataChange:{
					dataChange:true,
					
				},
			}
		},
		methods: {
			getlistsfromLib(e) {
				this.libLists = e;
			},
			showMedialists(e) {
				this.visible = e;
			},
			handleOk(e) {
				var ids = this.libLists.join(',');
				this.getOneFileData(ids)
				this.visible = false;
			},
			handleCancle() {
				this.visible = false;
			},
			tovideoComponents: function() {
				this.showtype = 2
			},
			toaudioComponents: function() {
				this.showtype = 3
			},
			getMediaData(id_key) {
				this.generated.generated=true;
				this.dataChange.dataChange=false;
				this.$apiRequest.post('/qrcode/getQrcodeList', {
					id_key: id_key
				}).then(res => {
					if (res.data.code == 200) {
						for(let i=0;i<res.data.data.content.lists.length;i++){
							res.data.data.content.lists[i].upload_hanlde={
								progress:101,
							}
						}
						this.videoData = res.data.data.content;
						this.extra=res.data.extra;
						if (res.data.type == 'video') {
							this.showtype = 2
						} else if (res.data.type = 'audio') {
							this.showtype = 3
						}
					}
				}).catch(err => {
					// message.error(err.message);
				})
			},
			getOneFileData(file_keys) {
				// this.generated.generated=false;
				this.$apiRequest.post('/qrcode/getBatchAttachInfor', {
					file_keys: file_keys
				}).then(res => {
					if (res.data.code == 200) {
						var arr = [];
						for (var i = 0; i < res.data.data.files.length; i++) {
							arr.push({
								id: res.data.data.files[i].id,
								sort: 0,
								title: res.data.data.files[i].filename,
								desc: "",
								cover: {
									id: 0,
									url: "",
								},
								filesize: res.data.data.files[i].filesize,
								url: res.data.data.files[i].url,
								width: res.data.data.files[i].width,
								height: res.data.data.files[i].height,
								duration: res.data.data.files[i].duration,
								extra: {
									title: "",
									desc: "",
									show_desc: 1,
									play_amount_set: 0,
									avatar: {
										id: 0,
										url: "",
									}
								},
								upload_hanlde:{
									progress:101,
								},
							})
						}
			
						this.videoData.lists = this.videoData.lists.concat(arr);
						if (res.data.data.type == 2) {
							this.showtype = 2
						} else if (res.data.data.type = 4) {
							this.showtype = 3
						}
					}
			
				}).catch(rres => {
					message.error(err.message);
				})
			}
		},
		watch:{
			videoData:{
				deep:true,
				handler(newval,oldval){
					this.dataChange.dataChange=true;
				}
			}
		},
		mounted() {
			var url = location.search;
			if (url.indexOf('?') != -1) { //判断是否有参数
				let arr = []; // 存储参数的数组
				let res = {}; // 存储最终JSON结果对象
				arr = url.split('?')[1].split('&'); // 获取浏览器地址栏中的参数

				for (let i = 0; i < arr.length; i++) { // 遍历参数
					if (arr[i].indexOf('=') != -1) { // 如果参数中有值
						let str = arr[i].split('=');
						res[str[0]] = str[1];
					} else { // 如果参数中无值
						res[arr[i]] = '';
					}
				}
				if (res.id_key !== undefined) {
					this.getMediaData(res.id_key)
				} else if (res.file_keys !== undefined) {
					this.getOneFileData(res.file_keys)
					this.videoData.change_type=parseInt(res.change_type)
				}
			}
			if (typeof createCodeStatus !="undefined"){
				if(createCodeStatus == 1){
					this.videoData.change_type=1
					this.videoData.createCodeStatus=1
				}else if(createCodeStatus == 2){
					this.videoData.change_type=2
					this.videoData.createCodeStatus=2
				}
			}
		}
	}
</script>

<style scoped>
	
	.mbm-shipin {
		color: #d5eaf8;

	}

	.mbm-yinle {
		color: #fae1cf;
	}

	.tplicon {
		font-size: 115px;
		line-height: 115px;
		position: absolute;
		bottom: 26px;
		right: 62px;
	}

	.tplbutton {
		width: 161px;
		height: 53px;
		background-color: #2e67f6;
		font-size: 16px;
		color: white;
		border: 0;
		outline: 0;
		border-radius: 26px;
		box-shadow: 0px 0px 15px #95b4ff;
		margin-top: 65px;
		cursor: pointer;
	}

	.tplinfo3>div {
		display: inline-block;
		line-height: 38px;
		padding: 0 14px;
		border-radius: 20px;
		border: 1px solid #e7e7e7;
		margin-right: 13px;
		min-width: 125px;
		text-align: center;
	}

	.tplinfo3>div:last-child {
		margin-right: 0px !important;

	}

	.tplinfo3 {
		font-size: 12px;
		color: #999;
		margin-top: 20px;
	}

	.cutline {
		width: 1px;
		height: 16px;
		background-color: #e7e7e7;
		margin: 0 10px;
	}

	.tplinfo2 {
		display: flex;
		align-items: center;
		color: #999;
		font-size: 14px;
		line-height: 16px;
		margin-top: 20px;
	}

	.tplinfo1 {
		font-size: 30px;
		line-height: 30px;
		margin-top: 48px;
	}

	.tplBottomR {
		width: 40px;
		height: 40px;
		border-radius: 8px;
		background-color: #e7e7e7;
		display: flex;
		align-items: center;
		cursor: pointer;
		justify-content: center;
	}

	.tplBottomL1 {
		font-size: 30px;
		color: #333;
		display: inline-block;
	}

	.tplBottomL2 {
		color: #999;
		display: inline-block;
		font-size: 14px;
		margin-left: 20px;
	}

	.tplBottomL {}

	.tplBottom {
		box-sizing: border-box;
		width: 100%;
		height: 123px;
		border-radius: 18px;
		border: 1px solid #e2e1de;
		margin-top: 51px;
		padding: 0 100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.width1200 {
		width: 1200px;
		margin: 0 auto;
	}

	.tplinfo {
		width: 580px;
		height: 324px;
		border-radius: 15px;
		background-color: #ffffff;
		box-shadow: 10px 10px 20px #f2f2f2;
		padding-left: 78px;
		position: relative;
	}

	.tpllists {
		margin-top: 84px;
		display: flex;
		justify-content: space-between;
	}

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.tplContainer {
		background-image: linear-gradient(#ecf3fc, #ffffff);
	}

	.tpltitle {
		font-size: 46px;
		line-height: 46px;
		text-align: center;
		padding-top: 75px;
	}
</style>
